module.exports = __webpack_public_path__ + "static/story5-03-800x533-29a19f0cf17d6aa8dd9fc5d2a123798f.jpg";